import { createContext, useContext } from "react";

// null = owner (unrestricted), object = team member with their permissions record
export const TeamMemberContext = createContext(null);

export function useTeamMember() {
  return useContext(TeamMemberContext);
}

export function useIsTeamMember() {
  const ctx = useContext(TeamMemberContext);
  return ctx !== null && ctx !== undefined && ctx.__isTeamMember === true;
}
